import type { InvoicingState } from './api'

/**
 * Why the customer cannot sign the final quote now, so no first invoice can bill it (USA-1336);
 * null when they can.
 */
export function finalQuoteProblem(state: InvoicingState['final_quote'] | undefined): string | null {
  switch (state) {
    case 'missing':
      return 'Not published yet.'
    case 'draft_after':
      return "A draft was published after it, so the customer can't sign it. Publish it again."
    case 'changed':
      return 'The quote changed after it was published. Publish it again.'
    case 'declined':
      return 'The customer asked for changes. Publish it again.'
    default:
      return null
  }
}
